module.exports = __webpack_public_path__ + "static/media/wallet.ef39f367.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/wallet.svg
// module id = 842
// module chunks = 21